import * as React from "react";
import { FC, PropsWithChildren, ReactNode } from "react";
import { Button, Gapped, Modal } from "react-ui";

import { ExceptionText } from "../../BasePicklist/PicklistModal/PicklistModal.styles";
import { BodyContainer, NotFoundContainer, PikedCounter } from "../../Common/Styles/PicklistModal.styles";
import { PicklistHint } from "../../BasePicklist/PicklistModal/PicklistModal.styles";
import { HeaderContainer, Title, WIDTH_CONTROL_IN_HEADER } from "../../Common/Styles/PicklistModal.styles";
import { Divider } from "../../../../Internals/DebugTools/ControlDebugTooltipContent/ControlDebugTooltipContent.styles";

export const Header: FC<
    PropsWithChildren<{
        title: string;
        description: ReactNode;
    }>
> = ({ children, title, description }) => (
    <Modal.Header>
        <HeaderContainer tabIndex={-1}>
            <Title data-tid="Title">{title}</Title>
            <PicklistHint width={WIDTH_CONTROL_IN_HEADER}>{description}</PicklistHint>
            {children}
        </HeaderContainer>
    </Modal.Header>
);

export const Footer: FC<{
    multiple: boolean;
    onCloseModal: () => void;
    onSaveAndClose: () => void;
}> = ({ multiple, onSaveAndClose, onCloseModal }) => (
    <Modal.Footer>
        <Gapped gap={8}>
            {multiple && (
                <Button use="primary" size="medium" onClick={onSaveAndClose} data-tid="TreePicklistSaveButton">
                    Сохранить и закрыть
                </Button>
            )}
            <Button
                use={multiple ? "default" : "primary"}
                size="medium"
                onClick={onCloseModal}
                data-tid="TreePicklistCancelButton">
                Закрыть
            </Button>
        </Gapped>
    </Modal.Footer>
);

export const Body: FC<PropsWithChildren<{ onKeyDown: () => void }>> = ({ children, onKeyDown }) => (
    <Modal.Body>
        <BodyContainer tabIndex={-1} onKeyDown={onKeyDown}>
            {children}
        </BodyContainer>
    </Modal.Body>
);

export const ResetBlock: FC<{ onReset: () => void }> = ({ onReset }) => (
    <>
        <PikedCounter>
            <Button data-tid={"TreePicklistResetButton"} onClick={onReset} borderless>
                Сбросить выбор
            </Button>
        </PikedCounter>
        <Divider />
    </>
);

export const NotFoundMessage: FC<{ searchValue: string }> = ({ searchValue }) => (
    <NotFoundContainer>{`Ничего не найдено по запросу "${searchValue}"`}</NotFoundContainer>
);

export const LoadingErrorMessage = () => (
    <ExceptionText>
        Во время запроса произошла ошибка. Попробуйте снова через несколько минут. Если проблема остается, обратитесь в
        техподдержку
    </ExceptionText>
);
